import { PomodoroMode } from '@/apps/Pomodoro/stores/usePomodoroStore';

export const formatTime = (seconds: number): string => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

export const getTotalTime = (mode: PomodoroMode, phase: 'focus' | 'break'): number => {
  if (phase === 'focus') {
    return mode === '25/5' ? 25 * 60 : 50 * 60;
  }
  return mode === '25/5' ? 5 * 60 : 10 * 60;
};
